import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../../store';
import SliderListItem from '../../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../../store/extensions';

const TextShadowDistanceListItem = (props) => {
    const { shadowSettingsDistance, updateTextElement, index, maxDropShadowDistance } = props;

    const onShadowDistanceChange = (value) => {
        previewHistoryBatch.start();

        updateTextElement(index, {
            shadowSettings: { distance: value }
        });
    };

    return (
        <SliderListItem
            title='Distance'
            value={shadowSettingsDistance}
            displayMultiplier={1}
            min={0}
            max={100}
            step={1}
            onValueChange={onShadowDistanceChange}
        />
    );
};

const mapStateToProps = (state, ownProps) => {
    const element = state.createPreview.present.videoSettings.text.textElements[ownProps.index];
    const shadowSettingsDistance = element && element.shadowSettings ? (element.shadowSettings.distance ?? 0) : 0;
    const { maxDropShadowDistance } = state.create.maxValues;

    return {
        shadowSettingsDistance,
        maxDropShadowDistance: maxDropShadowDistance || 20
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateTextElement = (index, properties) => dispatch(createActions.updateTextElement(index, properties));
    return { updateTextElement }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextShadowDistanceListItem);
